export default __webpack_public_path__ + "static/media/VideoContentThumbnailTemplate02.9529209d.png";